import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BrandAffinityMainContent } from 'modules/intelligentInsights/brandAffinityInsights/components/BrandAffinityMainContent';
import { selectIsBrandAffinityFeatureFlagOn } from 'core/userContext';
import { useCoreContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';
import { BrandAffinityError } from 'modules/intelligentInsights/brandAffinityInsights/components/layout/BrandAffinityError';
import { BrandAffinityEmpty } from 'modules/intelligentInsights/brandAffinityInsights/components/layout/BrandAffinityEmpty';
import { useDataManagementContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/dataManagement/DataManagementContext';
import { parsedResponseHasNoData } from 'modules/intelligentInsights/brandAffinityInsights/contexts/dataManagement/dataManagement.utils';
import { isDefaultCoreData } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/coreContext.utils';
import { BrandAffinityNotEnabled } from './BrandAffinityNotEnabled';

export const BrandAffinityReporting: FC = () => {
  const { insightsData, isError, isLoading } = useCoreContext();
  const { managedInsightsData } = useDataManagementContext();
  const hasCoreData = !isDefaultCoreData(insightsData);
  const content = useMemo(() => {
    if (!isLoading) {
      if (isError) {
        return <BrandAffinityError />;
      }

      if (hasCoreData && parsedResponseHasNoData(managedInsightsData)) {
        return <BrandAffinityEmpty />;
      }
    }

    return <BrandAffinityMainContent />;
  }, [isLoading, isError, hasCoreData]);
  return content;
};

export const BrandAffinityIndex: FC = () => {
  const isBrandAffinityEnabled = useSelector(selectIsBrandAffinityFeatureFlagOn);
  if (!isBrandAffinityEnabled) {
    return <BrandAffinityNotEnabled />;
  }
  return <BrandAffinityReporting />;
};
